// LoginForm.tsx
import { DialogActions, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
  getNotificationsProfile,
  updateNotificationsProfile,
} from 'lib/api/notifications';
import EnhancedBox from 'lib/designSystem/BigBox';
import CustomButton from 'lib/designSystem/Button';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import NotificationType from './components/NotificationType';

const useStyles = makeStyles(() => ({
  container: {
    maxWidth: '800px',
  },
  noPaddingMargin: {
    padding: '0p !important',
    margin: '0px',
  },
}));

const Notifications = (props: any) => {
  const { setSuccess, setFailure } = props;
  const dispatch = useDispatch();
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [types, setTypes] = useState([]);
  const [startValue, setStartValue] = useState(0);

  const simulateTabs = () => {
    const tabs = [];
    for (const type of types) {
      tabs.push({
        id: type,
        label: type,
        component: (
          <NotificationType
            notifications={notifications}
            type={type}
            setNotifications={setNotifications}
          />
        ),
      });
    }
    return tabs;
  };

  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const configResponse = await getNotificationsProfile(dispatch);
      setNotifications(configResponse.notificationsProfile || []);
      setTypes(configResponse.typesAvailable || []);
      setStartValue(0);
    } catch (error) {
      setFailure('Error al cargar las notificaciones');
    }

    setLoading(false);
  };

  const handleSave = async () => {
    console.log(notifications);
    setLoading(true);
    try {
      await updateNotificationsProfile(dispatch, notifications);
      setSuccess('Notificaciones guardadas correctamente');
      await fetchNotifications();
    } catch (error) {
      console.log(error);
      // setFailure('Error al guardar las notificaciones');
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchNotifications();
  }, []);

  if (loading) return <CenteredCircularProgress />;

  if (notifications.length === 0) {
    return (
      <div className={classes.container}>
        <EnhancedBox>
          <Typography fontWeight="bold">Mis Notificaciones</Typography>
          <Typography
            margin={'16px 0px'}
            width={'100%'}
            style={{ textWrap: 'pretty' }}
          >
            Tu rol no tiene notificaciones disponibles para configurar.
          </Typography>
        </EnhancedBox>
      </div>
    );
  }

  return (
    <div className={classes.container}>
      <EnhancedBox>
        <Typography variant="body1" fontWeight="bold">
          Mis Notificaciones
        </Typography>
        <Typography
          variant="body1"
          margin={'16px 0px'}
          width={'100%'}
          style={{ textWrap: 'pretty' }}
        >
          Habilita y deshabilita las notificaciones que deseas recibir según los
          productos que tengas contratados. Recuerda que cada rol tiene
          notificaciones específicas.
        </Typography>
        <EnhancedTab startValue={startValue} tabs={simulateTabs()} />
        <DialogActions>
          <CustomButton onClick={() => handleSave()} color="primary">
            Guardar
          </CustomButton>
        </DialogActions>
      </EnhancedBox>
    </div>
  );
};

export default Notifications;
